import { useTranslate } from "@similarweb/i18n-provider";
import { EmptyState } from "@similarweb/ui-components";

export const SerpOverlayErrorState = () => {
    const { translate } = useTranslate();

    return (
        <EmptyState
            title={translate("rankTracker.serpOverlay.error.title")}
            subtitle={translate("rankTracker.serpOverlay.error.subtitle")}
        />
    );
};
